/* src/components/LandingPage/Hero/index.tsx */
import { useIsMobile } from '../../../utils/isMobile';
import HeroMobile from './HeroMobile';
import HeroDesktop from './HeroDesktop';

export default function Hero() {
  const isMobile = useIsMobile();
  return isMobile ? <HeroMobile /> : <HeroDesktop />;
}
